import FormConfig from "../formConfig.js";
import { fun_PostAction } from "@/api/index";
import {
  fun_CheckLockBrand,
  fun_ECCAInit,
  fun_GetExpirationDate,
  fun_GetLockNumber,
  fun_IsIe
} from "../../../../../utils/commonLock";
// 引入转译方法
import CaLock from "@/components/common/calock";
import ProjectChoose from "../../components/projectChoose/index.vue";
import AuditHistoryRecord from "../../../components/auditHistoryRecord/index.vue";
import TenderPictureinfor from "../../../components/tenderPictureinfor/index.vue";
import { Loading } from "element-ui";
export default {
  data() {
    return {
      // 列表loading状态
      loading: false,
      // 表单对象
      form: {
        id: null, // 主键
        tenderReference: null, // 招标编号
        registrationId: null, // 招标登记编号
        announcementId: null, // 招标公告编号
        prjName: null, // 项目名称
        section: null, // 标段号
        tenderContent: null, // 招标内容
        tenderContentNum: null, // 招标内容编号
        tenderClassNumName: null, // 招标类别
        tenderTypeNumName: null, // 招标方式
        corpName: null, // 中标单位名称
        basicInfoId: null, // 中标单位名称编号
        personName: null, // 项目经理名称
        winningPrice: null, // 中标价（万元）
        state: null, // 状态
        stateName: null, // 状态名称
        regulators: null, // 区管代码
        regulatorsName: null, // 区管代码名称
        constructorId: null, // 项目负责人编号
        idCard: null, // 项目负责人身份证
        chageIdCard: null, // 变更后项目负责人身份证
        regLockBrand: null, // 锁品牌
        regBasicinfoChange: null, // 更换后的项目负责人主键
        basicinfoChangeName: null, // 更换后的项目经理（总监）名称
        unionPersonName: null, // 项目负责人名称
        oldLockBrand: null, // 锁品牌
        oldPersonId: null, // 旧锁负责人编号
        unionAgreementId: null, // 联合投标编号
        lockNo: null, // 锁编号
        digitalSignature: null, // 数字签名
      },
      // 表单错误
      errRules: {},
      // 表单配置
      formConfigList: FormConfig.configList(),
      // 页面类型
      controllerFlg: this.$route.query.controllerFlg,
      // 主键
      id: this.$route.query.id,
      // 全局加载
      fullLoading: null,
      // 数字证书数组
      regLockBrands: [],
      /******************************************项目负责人的要求******************************************/
      // 项目负责人的要求loading
      managerLoading: false,
      // 项目负责人的要求表数据
      managerTableData: [],
      // 项目负责人的要求列表基础数据
      managerTableColumns: [
        {
          label: "注册类型",
          prop: "tradeRequirementsName",
          align: "left"
        },
        {
          label: "注册等级",
          prop: "tradeLevelName"
        },
        {
          label: "注册专业",
          prop: "regTradeTypeName"
        },
        {
          label: "要求说明",
          prop: "requirements"
        }
      ],
      /*****************************联合体投标单位信息****************************/
      unionLoading: false, // 列表loading状态
      // 查询表单字段
      unionForm: {},
      // 表格基础数据
      unionTableColumns: [
        {
          label: "投标单位名称",
          prop: "corpName"
        },
        {
          label: "是否投标主体单位",
          prop: "isTenderMainName"
        },
      ],
      // 表格数据
      unionTableData: [],
    };
  },
  // 注册组件
  components: {
    CaLock, // CA锁
    ProjectChoose, // 项目信息
    AuditHistoryRecord, // 历史核验记录
    TenderPictureinfor // 附件页面
  },
  // 接收父组件传递的数据
  props: {
  
  },
  // 模板编译完成
  mounted() {
    // 打开loading
    this.loading = true;
    // 获取详情信息
    this.fun_Details();
    // 数字证书下拉框
    this.fun_GetLockBrandSelect();
  },
  // 自定义方法
  methods: {
    /**
     * @description 详情
     * @author
     */
    fun_Details() {
      // 请求，获取结果集
      fun_PostAction("/projectManagerRecordChange/detail", {
        id: this.id
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 数据回显
          this.form = data;
          // 页面样式设置
          this.fun_PageStyle();
          // 项目负责人的要求一览
          this.fun_ManagerList();
          // 联合体投标单位一览
          this.fun_BidUnionList();
          // 关闭loading
          this.loading = false;
        }
      });
    },
    /**
     * 项目负责人的要求一览
     * @author 任少杰
     */
    fun_ManagerList() {
      // 打开加载
      this.managerLoading = true;
      // 发起请求
      fun_PostAction("/tenderRegistration/tendererProjectManagerList", {
        registrationId: this.form.registrationId
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 操作成功
        if (result) {
          // 招标文件列表数据
          this.managerTableData = data;
        }
        // 关闭加载
        this.managerLoading = false;
      });
    },
    /**
     * 联合体投标单位
     */
    fun_BidUnionList() {
      // 联合体投标编号不为空
      if(this.form.unionAgreementId){
        // 打开遮罩
        this.unionLoading = true;
        // 发出请求
        fun_PostAction("/bidUnionAgreement/bidUnionAgreementTenderList", {
          unionAgreementId: this.form.unionAgreementId,
          tenderReference: this.form.tenderReference
        }).then(res => {
          // 解构res.data
          const { result, data } = res.data;
          // 操作成功
          if (result) {
            // 联合体投标单位
            this.unionTableData = data.records;
          }
          // 关闭遮罩
          this.unionLoading = false;
        });
      }
    },
    /**
     * 获取数字证书下拉框
     */
    fun_GetLockBrandSelect() {
      // 请求，获取结果集
      fun_PostAction("/dataDictionaryEntries/DictionaryCombobox", {
        zdid: "201512281759580003"
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 数字证书下拉框
          this.regLockBrands = data;
        }
      });
    },
    /**
     * 设置页面样式
     */
    fun_PageStyle(){
      // 如果不是新增
      if(this.controllerFlg != "insert"){
        // 定义CA证书类型
        let arr = ["oldLockBrand"];
        // 删除字段
        this.formConfigList[0].formConfigList = this.formConfigList[0].formConfigList.filter(
            e => !arr.includes(e.value)
        );
      }
      // 联合体投标编号不为空
      if(this.form.unionAgreementId){
        // 联合投标单位信息数量
        let num = 0;
        // 遍历表单
        this.formConfigList.map((e, i) => {
          // 如果是"联合投标单位信息"
          if (e.title == "联合投标单位信息") {
            num++;
          }
        });
        // 如果不存在联合投标信息
        if (num == 0) {
          // 截取
          this.formConfigList.splice(2, 0, {
            title: "联合投标单位信息",
            name: "3",
            icon: "",
            formConfigList: [
              {
                type: "slot",
                class: "formList",
                slotName: "unionList"
              }
            ]
          });
        }
      }else{
        // 遍历表单
        this.formConfigList.map((e, i) => {
          // 如果是"联合投标单位信息"
          if (e.title == "联合投标单位信息") {
            // 删除
            this.formConfigList.splice(i, 1);
          }
        });
      }
      // 如果招标编号为空
      if(!this.form.tenderReference){
        // 遍历表单
        this.formConfigList.map((e, i) => {
          // 如果是"项目负责人/总监变更申请"
          if (e.title == "项目负责人/总监变更申请") {
            // 删除
            this.formConfigList.splice(i, 1);
          }
        });
        // 遍历表单
        this.formConfigList.map((e, i) => {
          // 如果是"项目负责人/总监变更申请扫描件"
          if (e.title == "项目负责人/总监变更申请扫描件") {
            // 删除
            this.formConfigList.splice(i, 1);
          }
        });
      }
      // 如果招标编号不为空
      else{
        // 项目负责人/总监变更申请数量
        let num = 0;
        // 遍历表单
        this.formConfigList.map((e, i) => {
          // 如果是"项目负责人/总监变更申请"
          if (e.title == "项目负责人/总监变更申请") {
            num++;
          }
        });
        // 如果不存在联合投标信息
        if (num == 0) {
          // 下标
          let index = 2;
          // 联合体投标编号不为空
          if(this.form.unionAgreementId){
            index = 3;
          }
          // 截取
          this.formConfigList.splice(index, 0, {
            title: "项目负责人/总监变更申请",
            name: "3",
            icon: "",
            tipsList: [
              { text: "（1）请先插入投标项目负责人/总监的数字证书，成功读取信息后，请拔下投标项目负责人/总监的数字证书！" },
              { text: "（2）插入交易人数字证书，点击“保存”，提示“操作成功”后，上传《项目负责人/总监变更申请》扫描件！" },
            ],
            formConfigList: [
              {
                label: "CA数字证书类型：",
                type: "slot",
                value: "regLockBrand",
                slotName: "regLockBrand",
                class: "formBtn",
                width: "100%;"
              },
              {
                label: "投标项目负责人/总监：",
                value: "basicinfoChangeName",
                type: "input",
                disabled: true
              },
              {
                label: "证件类型：",
                value: "idCardTypeName",
                type: "input",
                disabled: true
              },
              {
                label: "证件号码：",
                value: "chageIdCard",
                type: "input",
                disabled: true
              },
            ]
          });
        }
        // 项目负责人/总监变更申请扫描件数量
        let uploadNum = 0;
        // 遍历表单
        this.formConfigList.map((e, i) => {
          // 如果是"项目负责人/总监变更申请扫描件"
          if (e.title == "项目负责人/总监变更申请扫描件") {
            uploadNum++;
          }
        });
        // 如果不存在联合投标信息
        if (uploadNum == 0) {
          // 下标
          let index = 3;
          // 联合体投标编号不为空
          if(this.form.unionAgreementId){
            index = 4;
          }
          // 截取
          this.formConfigList.splice(index, 0, {
            title: "项目负责人/总监变更申请扫描件",
            name: "4",
            icon: "",
            tipsList: [
              { text: "由投标人填写《项目负责人/总监变更申请》，写明项目负责人/总监的变更理由，并加盖单位公章后，原件彩扫上传。" },
            ],
            formConfigList: [
              {
                label: "变更申请扫描件：",
                type: "slot",
                slotName: "uploadFile",
                width: "100%",
              },
            ]
          });
        }
      }
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 回显字段
      this.form[i] = e;
    },
    /**
     * @description 保存
     * @author
     */
    fun_InsUpd(state) {
      // 验证当前表单
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        // 验证通过
        if (valid) {
          // 状态赋值
          this.form.state = state;
          // CA证书类型数量
          let num = 0;
          // 遍历表单
          this.formConfigList[0].formConfigList.map((e, i) => {
            // 如果是"CA证书类型"
            if (e.value == "oldLockBrand") {
              num++;
            }
          });
          // 如果存在旧ca证书类型
          if(num > 0){
            // 如果旧ca锁验证为空
            if(!this.form.oldLockBrand){
              // 提示
              this.$message.error("项目负责人（总监）未读取锁信息，请确认后选择！");
              return;
            }
            // 原项目负责人与读取原锁信息不一致，则提示
            if(this.form.oldPersonId != this.form.constructorId){
              // 提示
              this.$message.error("项目负责人（总监）不一致，请使用原项目负责人（总监）的CA锁或app账号重新操作！");
              return;
            }
          }
          // 原项目负责人与变更后项目负责人一致，则提示
          if(this.form.regBasicinfoChange == this.form.constructorId){
            // 提示
            this.$message.error("不能变更为同一项目负责人！");
            return;
          }
          // 打开遮罩
          this.fun_Loading();
          // 联合体投标编号不为空
          if(this.form.unionAgreementId){
            // 联合体验证
            this.fun_BidUnionAgreeValidate(state);
          }else{
            // 交易人资质验证
            this.fun_ValidateRequirement(state);
          }
        } else {
          // 提示
          this.$alert("页面存在错误信息，请检查后重试！", "warning");
          return false;
        }
      });
    },
    /**
     * 联合体验证
     */
    fun_BidUnionAgreeValidate(state){
      // 交易人基本信息
      let basicInfoIds = "";
      // 遍历表单
      this.unionTableData.map((e, i) => {
        // 编号为空时
        if (basicInfoIds == "" || basicInfoIds == null) {
          basicInfoIds = e.basicInfoId;
        } else {
          basicInfoIds = basicInfoIds + "," + e.basicInfoId;
        }
      });
      // 请求，获取结果集
      fun_PostAction("/projectManagerRecordChange/bidUnionAgreeValidate", {
        announcementId: this.form.announcementId, // 招标公告编号
        constructorId: this.form.regBasicinfoChange, // 变更后项目负责人编号
        isNeedPm: "1", // 是否需要项目负责人
        tenderReference: this.form.tenderReference, // 招标编号
        basicInfoIds: basicInfoIds, // 联合体投标单位
        flag: "change", // 标志
      }).then(res => {
        // 解构res.data
        const { result, msg } = res.data;
        // 操作成功
        if (result) {
          // 项目经理与单位检查
          this.fun_CheckCorpWork(state);
        } else {
          // 加载框取消
          this.fullLoading.close();
          // 错误消息
          this.$message.error(msg);
        }
      })
      .catch(() => {
        // 加载框取消
        this.fullLoading.close();
      });
    },
    /**
     * 交易人资质验证
     */
    fun_ValidateRequirement(state){
      // 请求，获取结果集
      fun_PostAction("/projectManagerRecordChange/validateRequirement", {
        announcementId: this.form.announcementId, // 招标公告编号
        projectManager: this.form.regBasicinfoChange, // 项目负责人编号
        isNeedPm: "1", // 是否需要项目负责人
        tenderReference: this.form.tenderReference, // 招标编号
        flag: "change", // 标志
      }).then(res => {
        // 解构res.data
        const { result, msg } = res.data;
        // 操作成功
        if (result) {
          // 项目经理与单位检查
          this.fun_CheckCorpWork(state);
        } else {
          // 加载框取消
          this.fullLoading.close();
          // 错误消息
          this.$message.error(msg);
        }
      })
    },
    /**
     * 项目经理与单位检查
     * @author shuhua
     */
    fun_CheckCorpWork(state) {
      // 创建中标候选人信息集合
      let winCandidates = new Array();
      // 初始化中标候选人信息
      let pmInfo = {"basicInfoId":"","xmjlsfz":"","xmjlxm":""};
      // 交易人基本信息
      let basicInfoIds = this.form.basicInfoId;
      // 企业编号
      pmInfo.basicInfoId = basicInfoIds;
      // 项目负责人身份证
      pmInfo.xmjlsfz = this.form.chageIdCard;
      // 项目负责人姓名
      pmInfo.xmjlxm =  this.form.basicinfoChangeName;
      // 加入集合
      winCandidates.push(pmInfo);
      // 发起请求
      fun_PostAction("/winningPublicity/checkCorpWork", {
        tenderReference: this.form.tenderReference,
        winCandidates: JSON.stringify(winCandidates),
        tenderContentNum: this.form.tenderContentNum,
        unionFlag: this.form.unionAgreementId?"2":"0",
        isNeedPm: "0"
      }).then(res => {
        // 解构res.data
        const { result, msg } = res.data;
        // 加载框取消
        this.fullLoading.close();
        // 操作成功
        if (result) {
          // 如果是提交
          if(state == "tj"){
            // 开启弹窗
            this.$refs.caLock.dialogCalock = true;
            // 签名数据, 交易人名称和日期
            this.$refs.caLock.data =
                this.form.prjName +
                this.form.announcementId +
                this.form.corpName +
                this.form.personName;
            // 状态
            this.$refs.caLock.state = state;
          }else{
            // 提交数据
            this.fun_Submit();
          }
        } else {
          // 错误提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 保存或修改的方法
     * @author shuhua
     */
    fun_SaveOrUpdate(state, lockNo, digitalSignature) {
      // ca弹窗关闭
      this.$refs.caLock.dialogCalock = false;
      // 赋值锁编号
      this.form.lockNo = lockNo;
      // 赋值数字签名
      this.form.digitalSignature = digitalSignature;
      // 弹出询问confirm
      this.$confirm("确定进行提交操作吗？提交后将不能修改信息，请谨慎操作！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // 提交数据
        this.fun_Submit();
      });
    },
    /**
     * 提交后台
     */
    fun_Submit(){
      // 打开遮罩
      this.fun_Loading();
      // 请求
      fun_PostAction("/projectManagerRecordChange/saveOrUpdate", {
        ...this.form, // form表单数据
        controllerFlg: this.controllerFlg // 操作标志
      }).then(res => {
        // 解构res.data
        const { result, msg } = res.data;
        // 加载框取消
        this.fullLoading.close();
        // 解析后台返回的结果集，判断是否成功
        if (result) {
          // 操作成功
          this.$message.success(msg);
          // 返回一览
          this.fun_Back();
        } else {
          // 请求失败，弹出失败msg的消息提示
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      });
    },
    /**
     * 打开历史核验记录弹窗
     */
    fun_OpenAuditHistoryRecord() {
      // 打开弹窗
      this.$refs.auditHistoryRecord.dialogVisible = true;
      // 请求接口
      this.$refs.auditHistoryRecord.fun_GetList();
    },
    /**
     * 附件上传
     */
    fun_GetPictureinfor() {
      // 打开弹窗
      this.$refs.tenderPictureinfor.dialogVisible = true;
      // 打开弹框时调用
      this.$refs.tenderPictureinfor.fun_GetOpen();
    },
    /**
     * 全局加载
     * @author zhouzhou
     */
    fun_Loading() {
      this.fullLoading = Loading.service({
        lock: true,
        text: "正在进行效验，请耐心等待...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 返回
      this.$router.back();
    },
    /**
     * 项目选择
     */
    fun_OpenProjectDialog(){
      // 打开弹窗
      this.$refs.projectChoose.dialogVisible = true;
      // 请求接口
      this.$refs.projectChoose.fun_GetList();
    },
    /**
     * 设置项目信息
     */
    fun_SetProject(e){
      // 招标编号
      this.form.tenderReference = e.id;
      // 项目名称
      this.form.prjName = e.prjName;
      // 招标公告编号
      this.form.announcementId = e.announcementId;
      // 招标登记编号
      this.form.registrationId = e.registrationId;
      // 标段号
      this.form.section = e.section;
      // 招标类别
      this.form.tenderClassNumName = e.tenderClassNumName;
      // 招标内容
      this.form.tenderContent = e.tenderContent;
      // 招标内容编号
      this.form.tenderContentNum = e.tenderContentNum;
      // 招标方式
      this.form.tenderTypeNumName = e.tenderTypeNumName;
      // 身份证号
      this.form.personName = e.personName;
      // 项目负责人
      this.form.idCard = e.idCard;
      // 项目负责人编号
      this.form.constructorId = e.constructorId;
      // 区管代码
      this.form.regulators = e.regulators;
      // 区管代码名称
      this.form.regulatorsName = e.regulatorsName;
      // 联合投标编号
      this.form.unionAgreementId = e.unionAgreementId;
      // 页面样式设置
      this.fun_PageStyle();
      // 项目负责人的要求一览
      this.fun_ManagerList();
      // 联合体投标单位一览
      this.fun_BidUnionList();
    },
    /**
     * 获取投标单位编号
     */
    fun_GetBasicInfos() {
      // 获取投标单位编号
      let corpId = "";
      // 遍历表单
      this.unionTableData.map((e, i) => {
        // 编号为空时
        if (corpId == "" || corpId == null) {
          corpId = e.basicInfoId;
        } else {
          corpId = corpId + "," + e.basicInfoId;
        }
      });
      return corpId;
    },
    /**
     * 读取数字证书信息
     */
    fun_OldRegPersonInfoChoose(){
      // 遮罩框加载
      this.fun_Loading();
      // 初始化
      fun_IsIe();
      // CA自动检测
      let lockBrand = fun_CheckLockBrand();
      // 是否检测到锁品牌
      if (lockBrand == "" || lockBrand == null) {
        // 加载框取消
        this.fullLoading.close();
        // 提示
        this.$message.error("请检查是否插入CA锁或者是否安装CA驱动，请确认后重新提交！");
        return;
      }
      // 控件初始化
      if (!fun_ECCAInit()) {
        // 加载框取消
        this.fullLoading.close();
        return;
      }
      // 设置锁品牌
      this.$set(this.form, "oldLockBrand", lockBrand);
      // 锁编号
      let lockNo = fun_GetLockNumber();
      // 证书到期日
      let expirationDate = fun_GetExpirationDate();
      // 获取投标单位编号
      let corpId = this.fun_GetBasicInfos();
      // 请求，获取结果集
      fun_PostAction("/caLock/checkRegPersonCaInfo", {
        lockNo: lockNo, // 锁编号
        lockBrand: lockBrand, // 锁品牌
        expirationDate: expirationDate, // 证书到期日
        corpId: corpId // 投标单位编号
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 加载框取消
        this.fullLoading.close();
        // 操作成功
        if (result) {
          // 设置旧项目负责人编号
          this.form.oldPersonId = data.regPersonId;
          // 原项目负责人编号不等于读取锁编号
          if(this.form.constructorId != data.regPersonId){
            // 提示
            this.$message.error("项目负责人（总监）不一致，请使用原项目负责人（总监）的CA锁或app账号重新操作！");
            return;
          }
        } else {
          this.$message.error(msg);
        }
      });
    },
    /**
     * 读取数字证书信息
     * @author shuhua
     */
    fun_RegPersonInfoChoose() {
      // 遮罩框加载
      this.fun_Loading();
      // 初始化
      fun_IsIe();
      // CA自动检测
      let lockBrand = fun_CheckLockBrand();
      // 是否检测到锁品牌
      if (lockBrand == "" || lockBrand == null) {
        // 加载框取消
        this.fullLoading.close();
        // 提示
        this.$message.error("请检查是否插入CA锁或者是否安装CA驱动，请确认后重新提交！");
        return;
      }
      // 控件初始化
      if (!fun_ECCAInit()) {
        // 加载框取消
        this.fullLoading.close();
        return;
      }
      // 设置锁品牌
      this.$set(this.form, "regLockBrand", lockBrand);
      // 锁编号
      let lockNo = fun_GetLockNumber();
      // 证书到期日
      let expirationDate = fun_GetExpirationDate();
      // 获取投标单位编号
      let corpId = this.fun_GetBasicInfos();
      // 请求，获取结果集
      fun_PostAction("/caLock/checkRegPersonCaInfo", {
        lockNo: lockNo, // 锁编号
        lockBrand: lockBrand, // 锁品牌
        expirationDate: expirationDate, // 证书到期日
        corpId: corpId // 投标单位编号
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 加载框取消
        this.fullLoading.close();
        // 操作成功
        if (result) {
          // 项目负责人主键
          this.form.regBasicinfoChange = data.regPersonId;
          // 项目负责人名称
          this.form.basicinfoChangeName = data.regPersonName;
          // 项目负责人证件类型名称
          this.form.idCardTypeName = data.idCardTypeName;
          // 项目负责人证件号码
          this.form.chageIdCard = data.idCard;
        } else {
          this.$message.error(msg);
        }
      });
    },
  }
};
